import { Document, Page, Text, View } from "@react-pdf/renderer";
import { Fragment } from "react";
import * as React from "react";
import { Nullable } from "../../../../types/utils";
import { OrderCategory, OrderCostingVersion, TApiOrderDetails } from "../../../api/endpoints/Order";
import RealtimeOrderPdfDetails from "./RealtimeOrderPdfDetails";
import {
  AdditionalChargesFootnote,
  EPUDefinitionFootnote, EPUOldLicenseNotice, LimitCapacityFootnote,
  LimitCapacityFootnoteLegacy,
  ResearchAndSmallBusinessFootnote
} from '../../Footnotes';
import { OrderPdfProps } from "../types";
import OrderDetailsPdf from "../OrderDetailsPdf";
import { TOrderProduct } from "../../../api/endpoints/OrderProduct";
import OrderCostSummaryPdf from "../OrderCostSummaryPdf";

interface IProps extends OrderPdfProps {
  order: TApiOrderDetails<OrderCategory.REALTIME>;
  products: Array<TOrderProduct<OrderCategory.REALTIME>>;
}

const RealtimeOrderPDF = (props: IProps) => {
  const {
    user,
    order,
    currentCostingVersion,
    products,
    sets,
    availableParams,
    styles
  } = props;

  return (
    <Document>
      <Page style={styles.pageStyles}>
        <OrderDetailsPdf {...props} />

        <View>
          <RealtimeOrderPdfDetails
            order={order}
            products={products}
            sets={sets}
            params={availableParams}
          />
        </View>

        <OrderCostSummaryPdf
          user={user}
          order={order}
          currentCostingVersion={currentCostingVersion}
          styles={styles}
          annualTotalCostFootnoteRef={'*'}
        />

        <View style={styles.disclaimers}>
          <View style={[styles.disclaimer, styles.flexRow]}>
            <View>
              <Text>
                *
              </Text>
            </View>

            <View style={styles.disclaimerContent}>
              {
                ['v1', 'v2', 'v3', 'v4', 'v5'].includes(order.cost.version) &&
                <Fragment>
                  <Text style={styles.listItem}>
                    <AdditionalChargesFootnote pdf />
                  </Text>

                  <Text style={styles.listItem}>
                    <EPUOldLicenseNotice pdf />
                  </Text>

                  <Text style={styles.listItem}>
                    <ResearchAndSmallBusinessFootnote pdf />
                  </Text>

                  <Text style={styles.listItem}>
                    <LimitCapacityFootnoteLegacy pdf />
                  </Text>
                </Fragment>
              }

              {
                order.cost.version === 'v6' &&
                <Fragment>
                  <Text style={styles.listItem}>
                    <LimitCapacityFootnote pdf />
                  </Text>
                </Fragment>
              }

            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

export default RealtimeOrderPDF;
